import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../layout";
import LayoutPage from "./Layout";

export function Layout(props) {
    return <LayoutPage {...props} />
}
